<template>
  <div class="tabbar2">
    <div class="tabbar2_box">
      <div class="left">
        <div
          class="d1"
          v-for="(item,index) in left"
          :key="index"
          :class="{act: i==index}"
          @click="ri(item,index)"
        >{{item.font}}</div>
      </div>
      <div class="right">
        <div class="right_top">热门推荐</div>
        <div class="right_box">
          <div v-for="(item,index) in box" :key="index" class="dbox">
            <a :href="item.url">
              <img v-lazy="item.img" alt />
            </a>
            <p class="p1">{{item.num}}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import data from "@/data/tabbar2_data.js";
// const show1 = () => import("@/components/show/show1.vue");
export default {
  name: "tabbar2",
  components: {
    // 组件注册
    // show1
  },
  data() {
    return {
      box: [],
      left: data.data.left,
      i: 0
    };
  },
  methods: {
    ri(item, index) {
      this.box = item.obj;
      this.i = index;
      console.log(this.i);
    }
  },

  mounted() {
    // Vue实例渲染完成后执行
    this.box = this.left[0].obj;
    // console.log(this.box);
  }
};
</script>
<style scoped lang="scss">
@import url("~@/assets/icon/iconfont.css");
.act {
  background-color: #fff;
  color: rgb(255, 44, 44) !important;
}

.left {
  float: left;
  // width: 4.3rem;
  width: 21vw;
  height: 100vh;
  // background-color: #f8f8f8;
  background-color: #f4f4f4;
  overflow: scroll;
  &::-webkit-scrollbar {
    /*隐藏滚轮*/
    display: none;
  }
  .d1 {
    // width: 4.3rem;
    width: 100%;
    text-align: center;
    line-height: 2.1rem;
    height: 2.1rem;
    font-size: 0.7rem;
    color: #666;
  }
}
.right {
  float: right;
  height: 100vh;
  width: 79vw;
  overflow: scroll;
  background-color: #fff;
  &::-webkit-scrollbar {
    /*隐藏滚轮*/
    display: none;
  }
  .p1 {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .right_top {
    width: 100%;
    height: 2rem;
    line-height: 2rem;
    font-weight: 600;
    color: #666;
    text-align: center;
    font-size: 0.9rem;
  }
  .right_box {
    width: 100%;
    display: flex;
    justify-content: space-around;
    flex-wrap: wrap;
    .dbox {
      width: 3.5rem;
      height: 4.5rem;
      margin: 0.3rem 0.5rem;
      // overflow: hidden;
      text-align: center;

      a {
        display: block;
        width: 3.5rem;
        height: 3.5rem;
        img {
          width: 100%;
          height: 100%;
        }
      }
      p {
        font-size: 0.7rem;
        color: #666;
        width: 100%;
        height: 1rem;
        line-height: 1rem;
      }
    }
  }
}
</style>
